import HundredBricksAPIError from '../../HundredBricksAPIError';
class DeveloperError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DeveloperError', ...args);
    }
}
export default DeveloperError;
